import React from 'react';

interface Props {
  n: string | number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_CLASS: Record<NonNullable<Props['size']>, string> = {
  sm: 'text-[28px]',
  md: 'text-[40px]',
  lg: 'text-[56px]',
};

export function EditorialNum({ n, size = 'md', className = '' }: Props) {
  return (
    <span
      className={[
        'font-display font-extrabold tabular-nums leading-none text-gold-600 tracking-[-0.02em]',
        SIZE_CLASS[size],
        className,
      ].join(' ')}
    >
      {n}
    </span>
  );
}
